import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

const CONTEXT = 'context';
const MAIN = 'main';

export class ContextCard extends Component {
  constructor(props) {
    super(props);

    this.renderNavItem = this.renderNavItem.bind(this);
    this.state = {
      activeContent: props.defaultContent,
    };
  }

  render() {
    const { props, state } = this;

    return (
      <div className="wp-card__spacer">
        <div className="wp-card__container">
          {!!props.floatingBanner && (
            <div className="wp-card-floatingBanner">{props.floatingBanner}</div>
          )}
          <div className="wp-card wp-contextCard">
            <div className="wp-card-left--desktop">
              <div className="wp-card-header">{props.headerContent}</div>

              <nav className="wp-card-nav--mobile">
                <ul>
                  {this.renderNavItem(CONTEXT)}
                  {this.renderNavItem(MAIN)}
                </ul>
              </nav>

              <div
                className={classNames('wp-card-context', {
                  'inactive--mobile': state.activeContent !== CONTEXT,
                })}
              >
                {props.contextContent}
              </div>
            </div>

            <div className="wp-card-right--desktop">
              <div
                className={classNames('wp-card-main', {
                  'inactive--mobile': state.activeContent !== MAIN,
                })}
              >
                {this.props.children}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderNavItem(section) {
    return (
      <li
        className={classNames('wp-card-nav--mobile__item', {
          active: this.state.activeContent === section,
        })}
        onClick={() => this.setState({ activeContent: section })}
      >
        {this.props[section + 'Label']}
      </li>
    );
  }
}

ContextCard.propTypes = {
  defaultContent: PropTypes.oneOf([CONTEXT, MAIN]),
  contextLabel: PropTypes.string.isRequired,
  mainLabel: PropTypes.string.isRequired,
  floatingBanner: PropTypes.node,
};

ContextCard.defaultProps = {
  defaultContent: CONTEXT,
  contextLabel: CONTEXT,
  mainLabel: MAIN,
};
